import connected from "standard/connected";
import define from "standard/define";
import disconnected from "standard/disconnected";
import * as filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import icon from "./icon";
import style from "./style";

@define("m-install-pwa")
class InstallPWA extends HTMLElement {
  #event;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return this.#event
      ? `
        <button class='${style.installPWA}' title='Instalar aplicativo'>
          ${icon()}
          <span>Instalar aplicativo</span>
        </button>
      `
      : "";
  }

  @on.click("button")
  [trait.onClick]() {
    this.#event?.prompt();
    return this;
  }

  @filter.prevent
  @repaint
  [trait.onBeforeInstallPrompt](event) {
    this.#event = event;
    return this;
  }

  @repaint
  [trait.onAppInstalled]() {
    this.#event = undefined;
    return this;
  }

  @connected
  [trait.addEventListener]() {
    window.addEventListener(
      "beforeinstallprompt",
      this[trait.onBeforeInstallPrompt].bind(this),
    );
    window.addEventListener(
      "appinstalled",
      this[trait.onAppInstalled].bind(this),
    );
    return this;
  }

  @disconnected
  [trait.removeEventListener]() {
    window.removeEventListener(
      "beforeinstallprompt",
      this[trait.onBeforeInstallPrompt].bind(this),
    );
    window.removeEventListener(
      "appinstalled",
      this[trait.onAppInstalled].bind(this),
    );
    return this;
  }
}

export default InstallPWA;
